import { useRouter } from "next/router";
import styles from "../../styles/components/searchFigma/ResultList.module.css";

export default function ResultList({ parts, handleSortChange }) {
  const router = useRouter();
  const { query } = router;

  const totalPartsCount = parts.reduce(
    (total, item) => total + (item.price?.length || 0),
    0
  );
  // 현재 Active 여부 구분자
  const currentSort = query.sort || "all";

  return (
    <div className={styles.frame01}>
      <div className={styles.frame010}>
        <div className={styles.frame0100}>
          <div className={styles.frame01000}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              className={styles.iconRectangle}
              fill="none"
            >
              <path
                d="M11.5556 2.66669H4.44445C3.46261 2.66669 2.66667 3.46263 2.66667 4.44446V11.5556C2.66667 12.5374 3.46261 13.3334 4.44445 13.3334H11.5556C12.5374 13.3334 13.3333 12.5374 13.3333 11.5556V4.44446C13.3333 3.46263 12.5374 2.66669 11.5556 2.66669Z"
                fill="currentColor"
              />
            </svg>
            <div className={`${styles.title} headline1`}>검색결과</div>
            <div className={`${styles.titleTablet} headline1`}>검색결과</div>
          </div>
          <div className={`${styles.totalCnt} body2`}>
            총 {totalPartsCount}건
          </div>
        </div>

        <div className={styles.frame0101}>
          <div
            className={styles.buttonWrapper}
            onClick={() => handleSortChange("all")}
          >
            <div
              className={
                currentSort === "all"
                  ? `${styles.buttonTextActive} body2`
                  : `${styles.buttonTextInActive} body2`
              }
            >
              메타서치
            </div>
          </div>
          <div className={styles.line}></div>

          <div
            className={styles.buttonWrapper}
            onClick={() => handleSortChange("day")}
          >
            <div
              className={
                currentSort === "day"
                  ? `${styles.buttonTextActive} body2`
                  : `${styles.buttonTextInActive} body2`
              }
            >
              납기순
            </div>
          </div>
          <div className={styles.line}></div>

          <div
            className={styles.buttonWrapper}
            onClick={() => handleSortChange("qty")}
          >
            <div
              className={
                currentSort === "qty"
                  ? `${styles.buttonTextActive} body2`
                  : `${styles.buttonTextInActive} body2`
              }
            >
              재고순
            </div>
          </div>
          <div className={styles.line}></div>

          <div
            className={styles.buttonWrapper}
            onClick={() => handleSortChange("keyword")}
          >
            <div
              className={
                currentSort === "keyword"
                  ? `${styles.buttonTextActive} body2`
                  : `${styles.buttonTextInActive} body2`
              }
            >
              검색어만
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
